import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";

import TestTrainSplit from "components/UnifiedProject/SelectData/TestTrainSplit";

class TestTrainSplitContainer extends React.Component {
  render() {
    return <TestTrainSplit {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateComparisonOptions: (comparisonOptions) =>
      dispatch(setupReducer.updateComparisonOptions(ownProps.runId, comparisonOptions))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;
  const runId = ownProps.runId;
  const datasetId = ownProps.datasetId;
  const nextId = ownProps.nextId;

  return {
    comparisonOptions: setupReducer.getComparisonOptions(state, runId),
    dataset: homeReducer.getDataset(state, datasetId),
    datasetRankedFields: homeReducer.getRankedFields(state, datasetId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(TestTrainSplitContainer);
